import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { AppConstants } from "../constants/constants";
import { translationsContentObject } from "../constants/DynamicTranslationContents";

@Pipe({
  name: "splitTranslation"
})
export class SplitTranslationPipe implements PipeTransform {
  siteLanguageCode: string;
  constructor(@Inject(LOCALE_ID) protected localeId: string) {
    this.siteLanguageCode = this.localeId;
  }
  
  // Currently this translation pipe will use DynamicTranslation contents.
  // And supports only translation with # delemiter to identify translation value
  // objectId param is required
  transform(value: string, objectId: string, splitBy: string = AppConstants.BLANK): string {
    
    // process for skill area and keywords  
    if(splitBy != AppConstants.BLANK) {
      var keys = value.split(splitBy).map(r => r.trim());

      var translatedWords = keys.map(r => {
        return this.siteLanguageCode === AppConstants.WELSH_LANG_CODE ? 
          this.checkTranslation(r, objectId) : r
      });

      return translatedWords.join(`${splitBy} `);
    } else {
      return this.siteLanguageCode === AppConstants.WELSH_LANG_CODE ?
        this.checkTranslation(value, objectId) : value;      
    }
  }

  checkTranslation(value:string, objectId: string) : string {

    //check first if an existing object is available
    var translated = translationsContentObject[value];

    if(translated) {
      return translated;
    } else {
      var translationList = Object.keys(translationsContentObject).filter(r => r.toLowerCase().includes(`${value?.toLowerCase()}${AppConstants.HASH}`));
      var result = translationList.length > 1 ?
      translationsContentObject[[value, objectId].join(AppConstants.HASH)] ?? this.checkObjectId(translationList, value) : 
      translationsContentObject[translationList[0]];
  
      return (result) ? result : value;
    }
  }

  checkObjectId(keys: string[], value: string): string {
    return translationsContentObject[keys[keys.findIndex( r => 
        r.split(AppConstants.HASH)[0] === value 
      )]];
  }
}